import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4eee7576"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, null, -1))
const _hoisted_2 = [
  _hoisted_1
]

import { ref, onBeforeMount } from "vue";
import { listCategories } from "@/services/portalService";
import { CategoryItem } from "@/models/Category";


export default /*#__PURE__*/_defineComponent({
  __name: 'MenuNav',
  props: {
  color: {
    type: String,
    default: "",
  },
},
  setup(__props) {

const props = __props;

const isActive = ref(false);



const categories = ref<CategoryItem[]>([]);

const fetchData = async () => {
  categories.value = await listCategories();
};

onBeforeMount(() => {
  fetchData();
});

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["menu", { active: isActive.value }])
  }, [
    _createElementVNode("div", {
      class: _normalizeClass(["menu-nav", { active: isActive.value }])
    }, [
      _createElementVNode("ul", null, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(categories.value, (cat) => {
          return (_openBlock(), _createElementBlock("li", {
            key: cat.hid
          }, [
            _createVNode(_component_router_link, {
              onClick: _cache[0] || (_cache[0] = ($event: any) => (isActive.value = false)),
              to: { name: 'category', params: { category: cat.slug } }
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(cat.name), 1)
              ]),
              _: 2
            }, 1032, ["to"])
          ]))
        }), 128))
      ])
    ], 2),
    _createElementVNode("div", {
      class: _normalizeClass(["toggle-icon", {
        active: isActive.value,
        'gold-pancake': __props.color === 'gold',
        'pink-pancake': __props.color === 'pink',
      }]),
      onClick: _cache[1] || (_cache[1] = ($event: any) => (isActive.value = !isActive.value))
    }, _hoisted_2, 2)
  ], 2))
}
}

})